<div class="text-wrap content-wrap" [@enter]>
    <div class="title my-color-blue">
        {{'__JOURNEY_STAGE__' | translate}} {{stage.current}}: <strong>{{stage.details.title}}</strong>
    </div>
    <div class="text">
        <div [innerHTML]="stage.details.text"></div>
    </div>
</div>
